import './style.less';
import { merge, findIndex } from 'lodash';

export default function($stateParams) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;
  vm.locations = [];

  function activate() {
    if (!vm.event) return;
    merge(vm.locations, vm.event.locations);

    if (!vm.selectedLocation) {
      const index = findIndex(vm.locations, { location: $stateParams.location });
      if (index === -1) vm.selectedLocation = vm.locations[0];
      else vm.selectedLocation = vm.locations[index];
    }

    vm.update({ location: vm.selectedLocation });
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/locationSelector/controller.js